import localStorage from 'redux-persist/es/storage';

/**
 * Retrieves an item from local storage and parses it to its original type.
 * @param key - The key of the item in local storage.
 * @returns The parsed value or null if not found or an error occurs.
 */
export async function GetStorage<T>(key: string): Promise<T | null> {
  try {
    const storageValue = await localStorage.getItem(key);
    return storageValue ? (JSON.parse(storageValue) as T) : null;
  } catch (error) {
    console.error(`Error retrieving key "${key}" from localStorage:`, error);
    return null;
  }
}

export async function SetStorage<T>(key: string, value: T): Promise<void> {
  try {
    await localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error setting key "${key}" in localStorage:`, error);
  }
}

export async function RemoveStorage(key: string): Promise<void> {
  try {
    await localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing key "${key}" from localStorage:`, error);
  }
}
